import { takeEvery, call, select, put } from 'redux-saga/effects';
import {
  UPDATE_LIBRARY_MENU,
  UPDATE_LIBRARY_DATA,
  DELETE_LIBRARY,
  SAVE_LIBRARY_CONFIG_SERVER,
  ADD_LIBRARY_TO_CACHE,
  AFTER_IMPORT_LIBRARY,
  OPEN_LIBRARY_FOLDER
} from './actionTypes';
import {
  getLibraryList,
  saveLibraryData,
  deleteLibraryById,
  getLibraryArray,
  libraryTypeList,
  BUFFER_SPICE_INDEX,
  getFolderDetail,
  libraryItem,
  BUFFER_INDEX,
  getIbisAmiFileList,
  GENERIC_INDEX,
  GENERIC_SPICE_INDEX,
  getLibraryFolderChildren,
  deleteFolderChild,
  LIBRARY_INDEX
} from '../../../../services/Andes_v2/library';
import {
  getLibraryArray as getPreLayoutLibraryArray
} from '../../../../services/PreLayout/PreLayoutLibrary';
import libraryConstructor from '@/services/Andes_v2/library/libraryConstructor';
import {
  IBIS_AMI,
  SPICE,
  BUFFER_SPICE,
} from '../../../../constants/libraryConstants';
import {
  updateLibraryMenu,
  updateLibraryStatus
} from './action';
import {
  updateTreeList
} from '../project/action';
import { LIBRARY_FOLDER_FILE } from '../../../../constants/treeConstants';
import { defaultTreeItems } from '../../../../services/Andes_v2';
import { getTreeItemsLoadObj } from '../../../../services/Andes_v2/helper/andesTree';

function* _updateLibraryList(action) {
  const { firstLoad } = action;
  let res = null;
  try {
    res = yield call(getLibraryList);
    if (!res) {
      return;
    }
  } catch (error) {
    console.error(error)
    return;
  }

  const { AndesV2Reducer: { project } } = yield select();
  const { treeItems } = project;
  let _treeItems = [...treeItems];
  let amiModelList = [];

  const treeItemsLoadObj = getTreeItemsLoadObj();
  if (_treeItems[LIBRARY_INDEX] && _treeItems[LIBRARY_INDEX].children) {
    for (const libraryType of Object.keys(treeItemsLoadObj)) {
      const { keys, indexs, initFunction } = treeItemsLoadObj[libraryType];
      const libraryList = [];
      for (const key of keys) {
        const list = initFunction === "getPreLayoutLibraryArray" ? getPreLayoutLibraryArray(key, res[key]) : getLibraryArray(key, res[key]);
        // update ami library list
        if (key === IBIS_AMI) {
          amiModelList = list;
        }
        libraryList.push(...list);
      }

      if (indexs.length === 1) {
        _treeItems[LIBRARY_INDEX].children[indexs[0]].children = libraryList;
      } else if (indexs.length === 2) {
        _treeItems[LIBRARY_INDEX].children[indexs[0]].children[indexs[1]].children = libraryList;
      } else if (indexs.length === 3) {
        _treeItems[LIBRARY_INDEX].children[indexs[0]].children[indexs[1]].children[indexs[2]].children = libraryList;
      }
    }

    firstLoad && libraryConstructor.clearAllCache();

    for (let item of amiModelList) {
      try {
        let list = yield call(getFolderDetail, item.id);
        list = Array.isArray(list) ? list.filter(it => !!it.fileName.match(".ibs")) : [];
        firstLoad && libraryConstructor.addLibrary(IBIS_AMI, item.id, { ...item, children: list });
        item.children = [];
        let fileNames = [];
        for (let it of list) {
          let ibisAmiList = getIbisAmiFileList(it, fileNames);
          item.children.push(
            new libraryItem(IBIS_AMI, {
              name: it.fileName,
              type: IBIS_AMI,
              id: item.id,
              dataType: LIBRARY_FOLDER_FILE,
              nodeClass: 'tree-library-folder-file'
            }));
          item.children.push(...(ibisAmiList || []).map(it =>
            new libraryItem(IBIS_AMI, {
              name: it.fileName,
              type: IBIS_AMI,
              id: item.id,
              dataType: LIBRARY_FOLDER_FILE,
              nodeClass: 'tree-library-folder-file'
            })))
          fileNames.push(...ibisAmiList.map(_it => _it.fileName));
        }
      } catch (error) {
        console.error(error)
      }
    }

    yield put(updateTreeList({ treeItems: [..._treeItems] }));

    if (firstLoad) {
      //save library to cache
      for (const type of libraryTypeList) {
        if (type === IBIS_AMI) {
          continue;
        }
        res[type] && res[type].forEach(item => {
          libraryConstructor.addLibrary(type, item.id, item);
        });
      }
      yield put(updateLibraryStatus());
    }
  }
}

function* _saveLibrary(action) {
  const { data, libraryType } = action;
  // libraryType - trace / via
  if (data) {
    const library = yield call(saveLibraryData, data);
    // add / update library
    libraryConstructor.addLibrary(libraryType, library.id, library);
    yield put(updateLibraryMenu());
  }
}

function* _delLibrary(action) {
  const { data } = action;
  const { id, type } = data;
  yield call(deleteLibraryById, id, type);
  //delete library cache by id
  libraryConstructor.delLibrary(type, id);

  if ([BUFFER_SPICE, SPICE].includes(type)) {
    const { AndesV2Reducer: { project: { treeItems } } } = yield select();
    let _treeItems = [...treeItems];
    let list = [];
    if (type === BUFFER_SPICE) {
      list = _treeItems[LIBRARY_INDEX].children[BUFFER_INDEX].children[BUFFER_SPICE_INDEX].children;
    } else if (type === SPICE) {
      list = _treeItems[LIBRARY_INDEX].children[GENERIC_INDEX].children[GENERIC_SPICE_INDEX].children;
    }

    let pathIds = data.path ? data.path.split('/') : [];
    pathIds = pathIds.filter(item => !!item)
    if (pathIds.length) {
      list = deleteFolderChild(list, id, pathIds);
    } else {
      list = list.filter(item => item.id !== id)
    }
    if (type === BUFFER_SPICE) {
      _treeItems[LIBRARY_INDEX].children[BUFFER_INDEX].children[BUFFER_SPICE_INDEX].children = list;
    } else if (type === SPICE) {
      _treeItems[LIBRARY_INDEX].children[GENERIC_INDEX].children[GENERIC_SPICE_INDEX].children = list;
    }
    yield put(updateTreeList({ treeItems: [..._treeItems] }));
  } else {
    //update menu
    yield put(updateLibraryMenu());
  }
}

function* updatePreLayoutLibrary(action) {
  const { model, config, templateVersion } = action;
  const { libId, libType, type, template } = model;
  const dataType = type;
  const data = {
    id: libId || "",
    name: template,
    type: libType,
    config,
    version: templateVersion
  }
  const res = yield call(saveLibraryData, data);
  libraryConstructor.addLibrary(dataType, res.id, res);
}

function* _addLibraryToCache(action) {
  const { fileList, modelType } = action;
  for (let file of fileList) {
    if (modelType === IBIS_AMI) {
      try {
        let list = yield call(getFolderDetail, file.id);
        list = Array.isArray(list) ? list.filter(it => !!it.fileName.match(".ibs")) : [];
        libraryConstructor.addLibrary(IBIS_AMI, file.id, { ...file, children: list });
      } catch (error) {
        console.error(error);
      }
    } else {
      libraryConstructor.addLibrary(modelType, file.id, file);
    }
  }
}

function* afterImportLibrary() {
  // clear the treeItem of the library
  const { AndesV2Reducer: { project: { treeItems } } } = yield select();
  const defaultLibraryMenu = defaultTreeItems.find(item => item.key === 'library')
  let _treeItems = treeItems.map(item => {
    if (item.key === 'library') {
      return JSON.parse(JSON.stringify(defaultLibraryMenu))
    }
    return item
  })

  yield put(updateTreeList({ treeItems: [..._treeItems] }));
  // update new library Menu，update libraryConstructor
  yield call(_updateLibraryList, { firstLoad: true })
}

function* _openFolder(action) {
  const { itemData, libraryType, filesInfo } = action;
  if (![BUFFER_SPICE, SPICE].includes(libraryType)) {
    return;
  }
  let uploadFiles = filesInfo && filesInfo.length ? getLibraryArray(libraryType, filesInfo) : [];
  let files = uploadFiles && uploadFiles.length ? uploadFiles : itemData ? [itemData] : [];

  const { AndesV2Reducer: { project: { treeItems } } } = yield select();
  let _treeItems = [...treeItems];
  try {
    let list = [];
    if (libraryType === BUFFER_SPICE) {
      list = _treeItems[LIBRARY_INDEX].children[BUFFER_INDEX].children[BUFFER_SPICE_INDEX].children;
    } else if (libraryType === SPICE) {
      list = _treeItems[LIBRARY_INDEX].children[GENERIC_INDEX].children[GENERIC_SPICE_INDEX].children;
    }

    if (files.length) {
      uploadFiles.length && list.push(...uploadFiles)
      for (let itemData of files) {
        if (!itemData.children && (itemData.fileType || "").toLowerCase() !== "Folder") {
          continue;
        }
        let library = itemData.id ? libraryConstructor.getLibrary(libraryType, itemData.id) : itemData;
        let res = [];
        if (!library || !library.children) {
          res = yield call(getLibraryFolderChildren, itemData.id);
          if (!res || !res[libraryType] || !res[libraryType].length) {
            return;
          }
          if (!library) {
            library = itemData;
          }
          library.children = getLibraryArray(libraryType, res[libraryType]);
          libraryConstructor.addLibrary(libraryType, itemData.id, library);
        }
        for (let data of library.children) {
          if (data.fileType !== "folder") {
            continue;
          }
          try {
            let childLibrary = libraryConstructor.getLibrary(libraryType, data.id);
            let childrenRes = {};
            if (!childLibrary || !childLibrary.children) {
              childrenRes = yield call(getLibraryFolderChildren, data.id);
              if (!childrenRes || !childrenRes[libraryType]) {
                continue;
              }
              data.children = getLibraryArray(libraryType, childrenRes[libraryType]);
              libraryConstructor.addLibrary(libraryType, data.id, data);
            }
          } catch (error) {
            console.error(error)
          }
        }

        let pathIds = itemData.path ? itemData.path.split('/') : [];
        pathIds = pathIds.filter(item => !!item)
        let newList = list;
        for (let i = 0; i < pathIds.length; i++) {
          const folderIndex = newList.findIndex(it => it.id === pathIds[i]);
          newList = newList[folderIndex] ? newList[folderIndex].children : [];
        }
        newList = library.children;
      }
    } else {
      for (let libItem of list) {
        if (libItem.fileType !== "folder") {
          continue;
        }
        try {
          let childLibrary = libraryConstructor.getLibrary(libraryType, libItem.id);
          let childrenRes = {};
          if (!childLibrary || !childLibrary.children) {
            childrenRes = yield call(getLibraryFolderChildren, libItem.id);
            if (!childrenRes || !childrenRes[libraryType] || !childrenRes[libraryType].length) {
              continue;
            }
            libItem.children = getLibraryArray(libraryType, childrenRes[libraryType] || []);
            libraryConstructor.addLibrary(libraryType, libItem.id, libItem);
          } else {
            libItem.children = childLibrary.children;
          }
        } catch (error) {
          console.error(error)
        }
      }
    }

    if (libraryType === BUFFER_SPICE) {
      _treeItems[LIBRARY_INDEX].children[BUFFER_INDEX].children[BUFFER_SPICE_INDEX].children = list;
    } else if (libraryType === SPICE) {
      _treeItems[LIBRARY_INDEX].children[GENERIC_INDEX].children[GENERIC_SPICE_INDEX].children = list;
    }
  } catch (error) {
    console.error(error)
  }
  yield put(updateTreeList({ treeItems: _treeItems }));
}

function* librarySaga() {
  yield takeEvery(UPDATE_LIBRARY_MENU, _updateLibraryList);
  yield takeEvery(UPDATE_LIBRARY_DATA, _saveLibrary);
  yield takeEvery(DELETE_LIBRARY, _delLibrary);
  yield takeEvery(SAVE_LIBRARY_CONFIG_SERVER, updatePreLayoutLibrary);
  yield takeEvery(ADD_LIBRARY_TO_CACHE, _addLibraryToCache);
  yield takeEvery(AFTER_IMPORT_LIBRARY, afterImportLibrary);
  yield takeEvery(OPEN_LIBRARY_FOLDER, _openFolder);
}

export default librarySaga;